export const inboundVoiceColumns = [
  {
    title: "Cola",
    dataIndex: "queue",
    key: "queue",
    ellipsis: true,
    width: 164,
  },
  {
    title: "Canal",
    dataIndex: "channel",
    key: "channel",
    width: 132,
  },
  {
    title: "Identificador",
    dataIndex: "identifier",
    key: "identifier",
    width: 132,
  },
  {
    title: "Contestadas",
    dataIndex: "contestadas",
    key: "contestadas",
    width: 132,
  },
  {
    title: "Abandonadas",
    dataIndex: "no_contestadas",
    key: "no_contestadas",
    width: 132,
  },
  {
    title: "Total",
    dataIndex: "total",
    key: "total",
    width: 106,
  },
  {
    title: "Segundos consumidos",
    dataIndex: "total_seconds",
    key: "total_seconds",
    width: 176,
    customRender: ({ text }) => text ?? 0,
  },
  {
    title: "Nivel de servicio (cantidad)",
    dataIndex: "atendidas_ns",
    key: "atendidas_ns",
    width: 208,
  },
  {
    title: "%NS",
    dataIndex: "nivel_servicio",
    key: "nivel_servicio",
    slots: { customRender: "percentCell" },
    width: 100,
  },
  {
    title: "Nivel de abandono",
    dataIndex: "nivel_abandono",
    key: "nivel_abandono",
    slots: { customRender: "percentCell" },
    width: 180,
  },
  // {
  //   title: "Umbral de espera (seg)",
  //   dataIndex: "umbral_espera",
  //   key: "umbral_espera",
  //   width: 180,
  // },
];
